import { useState } from 'react';
import { Header } from '@/components/Header';
import { Navigation, NavigationTab } from '@/components/Navigation';
import { Overview } from '@/pages/Overview';
import { Pipeline } from '@/pages/Pipeline';
import { SequenceEditor } from '@/pages/SequenceEditor';
import { Analytics } from '@/pages/Analytics';
import { PastClients } from '@/pages/PastClients';
import { useChannel } from '@/hooks/useChannel';

function App() {
  const [activeTab, setActiveTab] = useState<NavigationTab>('overview');
  const { selectedChannel, switchChannel } = useChannel();

  const renderMainContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview selectedChannel={selectedChannel} />;
      case 'pipeline':
        return <Pipeline selectedChannel={selectedChannel} />;
      case 'sequences':
        return <SequenceEditor selectedChannel={selectedChannel} />;
      case 'analytics':
        return <Analytics selectedChannel={selectedChannel} />;
      case 'past-clients':
        return <PastClients selectedChannel={selectedChannel} />;
      default:
        return <Overview selectedChannel={selectedChannel} />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 text-slate-50">
      <Header 
        selectedChannel={selectedChannel}
        onChannelChange={switchChannel}
      />
      
      <Navigation 
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      
      <main className="min-h-[calc(100vh-144px)]">
        {renderMainContent()}
      </main>
    </div>
  );
}

export default App;